import _ from 'lodash';
import getMaxDaysForTermMonths from './getMaxDaysForTermMonths';

interface CalculatedInterestAmounts {
    annualInterest: number;
    interestPayable: number;
    monthlyInterest: number;
    monthlyInterestDefault: number;
}

export function calculateInterestAmounts(
    loanAmount: number,
    interestRate: number,
    termMonths: number,
    defaultInterestRate: number = null,
): CalculatedInterestAmounts {
    defaultInterestRate = null === defaultInterestRate ? interestRate + 10 : defaultInterestRate;

    const dailyInterest: number = _.round(loanAmount * (interestRate / 100) / 365, 2);
    const dailyDefaultInterest: number = _.round(loanAmount * (defaultInterestRate / 100) / 365, 2);

    const monthlyInterest: number = dailyInterest * 31;
    const monthlyInterestDefault: number = dailyDefaultInterest * 31;
    const annualInterest: number = dailyInterest * 366;
    const interestPayable: number = dailyInterest * getMaxDaysForTermMonths(termMonths);

    return {
        annualInterest: _.round(annualInterest, 2),
        interestPayable: _.round(interestPayable, 2),
        monthlyInterest: _.round(monthlyInterest, 2),
        monthlyInterestDefault: _.round(monthlyInterestDefault, 2),
    };
}
